import {
  fetchLoadActiveUserCount,
  fetchLoadDeepTestCount,
  fetchLoadReviewCount,
  fetchLoadSimpleMeasureCount,
  fetchLoadSimpleTestCount,
  fetchLoadUserTotalCount,
} from "api/admin/dashboard";
import DashboardMultiChartPie from "components/admin/dashboard/daahboard.multi.chart.pie";
import DashboardMultiChartLine from "components/admin/dashboard/dashboard.multi.chart.line";
import DashboardMultiTotalBox from "components/admin/dashboard/dashboard.multi.total.box";
import DashboardSearch from "components/admin/dashboard/dashboard.search";
import { PeriodOption } from "components/admin/dashboard/dashboard.select";
import {
  DashboardCumulativeDatas,
  SearchDateParams,
} from "interface/admin/interface.dashboard";
import { useEffect, useState } from "react";
import { ChartWrap } from "style/admin/dashboard";
import { StatisticsItemsWrap } from "style/admin/inquiry";
import { getPreviousRange } from "utils/dashboard.util";

interface SearchConditionProps {
  startDate: string;
  endDate: string;
  period: string;
}

// 기간별 통계
const DashboardMultiStatistics = () => {
  const [data, setData] = useState<DashboardCumulativeDatas | null>(null);
  const [period, setPeriod] = useState<PeriodOption>();
  const [selectBox, setSelectBox] = useState<string>();

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const dateHandeler = ({
    startDate,
    endDate,
    period,
  }: SearchConditionProps) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setPeriod(period as PeriodOption); // ✅ 타입 단언 추가
  };

  const selectHandler = (selectItem: string) => {
    setSelectBox(selectItem);
  };

  useEffect(() => {
    if (!startDate || !endDate || !period) return;

    const fetchAll = async () => {
      try {
        const fullParams: SearchDateParams = {
          searchStartDt: startDate,
          searchEndDt: endDate,
        };

        const { prevStart, prevEnd } = getPreviousRange(
          startDate,
          endDate,
          period
        );

        const prevParams: SearchDateParams = {
          searchStartDt: prevStart,
          searchEndDt: prevEnd,
        };

        const [
          userTotalCount,
          simpleTestCount,
          simpleMeasureCount,
          reviewCount,
          deepTestCount,
          activeUserCount,

          prevUserTotalCount,
          prevSimpleTestCount,
          prevSimpleMeasureCount,
          prevReviewCount,
          prevDeepTestCount,
          prevActiveUserCount,
        ] = await Promise.all([
          fetchLoadUserTotalCount(fullParams),
          fetchLoadSimpleTestCount(fullParams),
          fetchLoadSimpleMeasureCount(fullParams),
          fetchLoadReviewCount(fullParams),
          fetchLoadDeepTestCount(fullParams),
          fetchLoadActiveUserCount(fullParams),

          fetchLoadUserTotalCount(prevParams),
          fetchLoadSimpleTestCount(prevParams),
          fetchLoadSimpleMeasureCount(prevParams),
          fetchLoadReviewCount(prevParams),
          fetchLoadDeepTestCount(prevParams),
          fetchLoadActiveUserCount(prevParams),
        ]);

        setData({
          current: {
            userTotalCount: userTotalCount.result,
            simpleTestCount: simpleTestCount.result,
            simpleMeasureCount: simpleMeasureCount.result,
            reviewCount: reviewCount.result,
            deepTestCount: deepTestCount.result,
            activeUserCount: activeUserCount.result,
          },
          previous: {
            userTotalCount: prevUserTotalCount.result,
            simpleTestCount: prevSimpleTestCount.result,
            simpleMeasureCount: prevSimpleMeasureCount.result,
            reviewCount: prevReviewCount.result,
            deepTestCount: prevDeepTestCount.result,
            activeUserCount: prevActiveUserCount.result,
          },
        });
      } catch (err) {
        console.error("통계 조회 실패:", err);
      }
    };

    fetchAll();
  }, [startDate, endDate, period]);

  return (
    <StatisticsItemsWrap>
      <DashboardSearch dateHandeler={dateHandeler} />
      {data && period && (
        <DashboardMultiTotalBox
          data={data}
          period={period}
          selectHandler={selectHandler}
        />
      )}
      <ChartWrap>
        {selectBox && startDate && endDate && period && (
          <DashboardMultiChartLine
            selectBox={selectBox}
            startDate={startDate}
            endDate={endDate}
            period={period}
          />
        )}
        {data && (selectBox === "newUser" || selectBox === "activeUser") && (
          <DashboardMultiChartPie data={data} selectBox={selectBox} />
        )}
      </ChartWrap>
    </StatisticsItemsWrap>
  );
};

export default DashboardMultiStatistics;
